import http from '@/http';

export default class UsuarioService {

	getUsuarios() {
		console.log('getUsuarios ...');
		return http.get('usuario').then(res => res.data);
    }

	update(usuario) {
		console.log('update ...');
		return http.put(`usuario/${usuario.id}`, usuario).then(res => res.data);
    }

	getUsuarioByIdusuario(idusuario) {
		console.log('getUsusuarioByIdusuario ...');
		return http.get(`usuario/${idusuario}`).then(res => res.data);
    }

	create(usuario) {
		console.log('create ...');
		return http.post('usuario', usuario).then(res => res.data);
    }

	delete(usuario) {
		console.log('create ...');
		return http.delete(`usuario/${usuario.id}`).then(res => res.data);
    }

	getUsuariosCandidatos() {
		console.log('getUsuarios ...');
		return http.get('usuario/candidatos').then(res => res.data);
    }

	validarEmailCandidato(idUsuario) {
		console.log('validar email candidato ...');
		return http.put(`usuario/adm/confirmarEmail/${idUsuario}`).then(res => res.data);
    }

	async getNomeUsuario(idusuario){
		let nome = 'Não encontrado!';
		await http.get(`usuario/${idusuario}`)
			.then(res => {
				nome = res.data.nome;
			})
		return nome;
	}

}
